module.exports = __webpack_public_path__ + "static/media/paredes_vivas_2.6704247b.jpg";